import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} fill="none" ref={ref} {...props}>
    <g stroke="#81BC3F" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path fill="#fff" d="M5.003 9.464a4.464 4.464 0 1 0 0-8.928 4.464 4.464 0 0 0 0 8.928Z" />
      <path d="m3.21 5.446 1.3 1.34C5.12 5.03 5.63 4.26 6.782 3.214" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h10v10H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconCheckMark = memo(ForwardRef);
export default IconCheckMark;